import { gql } from '@apollo/client';

export const AI_CREDITS_BALANCE = gql`
  query aiCreditsBalance {
    aiCreditsBalance
  }
`;

export const AI_CREDITS_CHECKOUT_LINK = gql`
  query aiCreditsCheckoutLink($plan: String!) {
    aiCreditsCheckoutLink(plan: $plan)
  }
`;
